module.exports = {
  "zones": {
    "Asia/Pyongyang": ["z", {
      "wallclock": 1525476600000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 32400000,
      "posix": 1525446000000,
      "save": 0
    }, {
      "wallclock": 1439596800000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 30600000,
      "posix": 1439564400000,
      "save": 0
    }, {
      "wallclock": -768614400000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 32400000,
      "posix": -768646800000,
      "save": 0
    }, {
      "wallclock": -1830384000000,
      "format": "JST",
      "abbrev": "JST",
      "offset": 32400000,
      "posix": -1830414600000,
      "save": 0
    }, {
      "wallclock": -1948752000000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 30600000,
      "posix": -1948782180000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 30180000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};